<script setup lang="ts">
import { useCustomField, type CustomFieldProps } from "@formwerk/core";
import { computed } from "vue";

type SelectOption = {
  value: string;
  label: string;
};

const props = withDefaults(defineProps<CustomFieldProps<string> & { options: SelectOption[]; hideLabel?: boolean }>(), { hideLabel: false });
const { labelProps, controlProps, errorMessage, errorMessageProps, isTouched, setValue, fieldValue, descriptionProps } = useCustomField<string>(props);
const selected = computed({
  get: () => fieldValue.value,
  set: setValue,
});
</script>

<template>
  <div class="">
    <label v-bind="labelProps" :class="{ 'sr-only': props.hideLabel }">
      {{ props.label }}
    </label>
    <select v-model="selected" v-bind="controlProps">
      <option v-for="option in props.options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
    <div v-if="description" v-bind="descriptionProps" class="text-sm text-muted">
      {{ description }}
    </div>
  </div>
</template>
